const METRICS = [
  { value: "94%", label: "Engagements that ship on schedule" },
  { value: "6 wk", label: "Median time to first production deploy" },
  { value: "32", label: "Teams shipped with since 2019" },
  { value: "4.9", label: "Average client satisfaction (out of 5)" },
];

export default function Metrics() {
  return (
    <section className="section section-tight" id="metrics">
      <div className="container">
        <header className="section-header">
          <p className="section-eyebrow">By the numbers</p>
          <h2 className="section-title">Results we can point at.</h2>
        </header>
        <dl className="metric-grid">
          {METRICS.map((m) => (
            <div key={m.label} className="metric">
              <dt className="metric-label">{m.label}</dt>
              <dd className="metric-value">{m.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
